import { Observable } from 'rxjs';
import { User } from './user';
import { Credentials } from './credentials';

export class UserCheckResult {
  private readonly _result: boolean;
  private readonly _user: User;
  constructor(user: User, result: boolean) {
    this._user = user;
    this._result = result;
  }
  get result() {
    return this._result;
  }
  get user() {
    return this._user;
  }
}

export abstract class UserChecker {
  abstract check(credentials: Credentials): Observable<UserCheckResult>;
}
